import { create } from 'zustand'

type Theme = 'light' | 'dark'

function applyTheme(theme: Theme) {
  if (theme === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark')
  } else {
    document.documentElement.removeAttribute('data-theme')
  }
}

interface ThemeState {
  theme: Theme
  toggle(): void
}

const stored = localStorage.getItem('ielts-buddy:theme') as Theme | null
const initial: Theme =
  stored ??
  (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
applyTheme(initial)

export const useThemeStore = create<ThemeState>((set) => ({
  theme: initial,
  toggle() {
    set((s) => {
      const next: Theme = s.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('ielts-buddy:theme', next)
      applyTheme(next)
      return { theme: next }
    })
  },
}))
